import React, { useState, useRef, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import widgetplaceholder from "../../../assets/img/widgets/widget-placeholder.jpg";
import { useRouteMatch } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { withNamespaces } from "react-i18next";
import { isEmpty } from "lodash";

import "~/assets/css/icons.css";
import "~/assets/css/styles.css";

import { getBaseWidgets } from "~/pages/Admin/SystemSettings/actions";
import {
  saveUserWidget,
  saveOrgWidget,
  updateUserSettings,
  updateOrganizationCollection,
} from "~/pages/User/actions";

const styles = {
  img: { borderRadius: "3%", width: "100%", height: "auto" },
};

const AddWidgetComponent = ({ t, scope }) => {
  const dispatch = useDispatch();
  const { baseWidgets, isUpdated, configuration } = useSelector(
    (state) => state.adminConfigReducer
  );
  const { userSettings, lastAddedWidget, organizationCollection } = useSelector(
    (state) => state.userSettingsReducer
  );

  const isProductionMode = configuration?.productionMode ?? true;
  const isOrgReady = configuration?.orgReady ?? true;

  const [show, setShow] = useState(false);
  const ref = useRef(null);
  const { path } = useRouteMatch();

  useEffect(() => {
    dispatch(getBaseWidgets());
  }, [dispatch, isUpdated]);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const adicionarWidget = (item) => {
    const payload = { widgetId: item.id };
    scope === "org"
      ? dispatch(saveOrgWidget(payload))
      : dispatch(saveUserWidget(payload));
    handleClose();
  };

  useEffect(() => {
    if (!lastAddedWidget) return;

    let dashboards =
      scope === "org"
        ? organizationCollection.dashboards
        : userSettings.dashboards;

    let dashboards_ = dashboards || [];
    if (!dashboards_ || dashboards_.length === 0) {
      dashboards_ = [
        {
          application: path,
          placements: [[]],
        },
      ];
    }

    let dashboard = dashboards_.find((item) => item.application === path);

    if (!dashboard) {
      dashboard = { application: path, placements: [[]] };
      dashboards_ = [...dashboards_, dashboard];
    }

    const placements = dashboard.placements || [[]];
    const newPlacements = [...placements];
    newPlacements[0] = [...placements[0], lastAddedWidget.id];

    const newDashboards = dashboards_.map((item) =>
      item.application === path ? { ...item, placements: newPlacements } : item
    );

    const existsInNewDashboards = newDashboards.some(
      (item) => item.application === path
    );
    const finalDashboards = existsInNewDashboards
      ? newDashboards
      : [...newDashboards, { ...dashboard, placements: newPlacements }];

    const payload =
      scope === "org"
        ? { ...organizationCollection, dashboards: finalDashboards }
        : { ...userSettings, dashboards: finalDashboards };

    scope === "org"
      ? dispatch(updateOrganizationCollection(payload))
      : dispatch(updateUserSettings(payload));
  }, [
    lastAddedWidget,
    scope,
    path,
    userSettings,
    organizationCollection,
    dispatch,
  ]);

  const renderWidget = (item, index) => (
    <div key={index}>
      <hr />
      <div className="row position-relative">
        <div className="col-md-4">
          <img style={styles.img} src={widgetplaceholder} alt="Widget" />
        </div>
        <div className="col-md-8 position-static">
          <h6 className="font-weight-bold">{t(`${item.component}.title`)}</h6>
          <button
            id={`button_addWidgetComponent_productionMode_add_${index}`}
            type="button"
            className="btn float-right text-success"
            onClick={() => adicionarWidget(item)}
          >
            <i className="icon-add"></i>
          </button>
        </div>
      </div>
    </div>
  );

  const widgets = !isEmpty(baseWidgets)
    ? baseWidgets
        .filter((item) =>
          isProductionMode
            ? scope === "org"
              ? item.production || item.orgReady
              : item.production && !item.orgReady
            : true
        )
        .map(renderWidget)
    : null;

  return (
    <div className="widget-list-wrapper-add" ref={ref} tabIndex="-1">
      <a onClick={handleShow} className="add-widget-img">
        <i
          className="icon-add"
          style={{ fontSize: "50px", verticalAlign: "text-top" }}
        />
      </a>

      <Modal show={show} onHide={handleClose} dialogClassName="custom-modal">
        <Modal.Header closeButton>
          <Modal.Title>{t("AddWidgetComponent.title")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{widgets}</Modal.Body>
        <Modal.Footer>
          <Button
            id="button_addWidgetComponent_cancel"
            variant="danger"
            onClick={handleClose}
          >
            {t("general.cancel")}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default withNamespaces()(AddWidgetComponent);
